
            const data = {"name":"close","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M1 52.55L23.56 30 1 7.44 7.44 1 30 23.56 52.56 1 59 7.44 36.44 30 59 52.55 52.55 59 30 36.44 7.44 59z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                